import Script from "next/script"
import { JobPage } from "components/Templates/JobPage"
import { fetchTranslations } from "utils"
import { useState } from "react"

export default function Archive({ query, locale, currentDomain, subscriptionToggle, recaptchaSiteKey, currentEnv, domain }) {
  const [atlasRef, setAtlasRef] = useState()

  return (
    <>
      <Script
        defer
        strategy="lazyOnload"
        onLoad={() => {
          setAtlasRef(window.atlas)
        }}
        src="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js"
      ></Script>
      {JobPage({
        whichTranslation: "Archive",
        which: "archive",
        query,
        locale,
        atlasRef,
        subscriptionToggle,
        recaptchaSiteKey,
        currentEnv,
        currentDomain,
        domain,
      })}
    </>
  )
}

export async function getServerSideProps({ locale, query }) {
  const archive = await fetchTranslations({ locale, title: "Archive" })
  const findJobs = await fetchTranslations({ locale, title: "FindJobs" })
  const jobSearch = await fetchTranslations({ locale, title: "JobSearch" })
  const jobListing = await fetchTranslations({ locale, title: "JobListing" })
  const subscriptions = await fetchTranslations({
    locale,
    title: "Subscriptions",
  })

  return {
    props: {
      query: {
        search: query.search || "",
        location: query.location || "",
        start_date: query.start_date || "",
        job_type: query.job_type || "all",
        job_status: query.job_status || "all",
        sort: query.sort || "relevancy",
      },
      locale,
      messages: {
        ...archive,
        ...findJobs,
        ...jobSearch,
        ...jobListing,
        ...subscriptions,
      },
      currentEnv: process.env.K8S_NAMESPACE || "",
      currentDomain: process.env.NEXT_PUBLIC_CURRENT_DOMAIN || `https://dev.seasonaljobs.dol.gov`,
      domain: process.env.NEXT_PUBLIC_DRUPAL_API || `https://dev.api.seasonaljobs.dol.gov`,
      subscriptionToggle: process.env.SJ_SUBSCRIPTION_TOGGLE || null,
      recaptchaSiteKey: process.env.RECAPTCHA_SJ_KEY_V3 || null,
    },
  }
}
